import { useEffect, useRef } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

const scrollPositions: Record<string, number> = {};

const ScrollRestoration: React.FC<RouteComponentProps> = ({ history, location }) => {
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    const unlisten = history.listen((newLocation, action) => {
      scrollPositions[prevPath.current] = window.scrollY;

      prevPath.current = newLocation.pathname;
    });

    return () => {
      unlisten();
    };
  }, [history]);

  useEffect(() => {
    const y = scrollPositions[location.pathname];
    if (typeof y === 'number') {
      requestAnimationFrame(() => {
        window.scrollTo(0, y);
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return null;
};

export default withRouter(ScrollRestoration);
